import { Skeleton } from '@/shared/components/ui/skeleton';
import { SIDEBAR_SKELETON_ROWS } from '@/shared/config/sidebar';

/** Suspense fallback for the condensed sidebar org tree. */
export function SidebarListSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-0.5 px-2 pt-2">
      <Skeleton className="mb-1.5 h-7 w-full rounded-md" />
      {SIDEBAR_SKELETON_ROWS.map((row) => (
        <Skeleton key={row} className="h-7 w-full rounded-md" />
      ))}
    </div>
  );
}
